import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterModule} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import { BreadcrumbModel } from '../../../../domain/model/common/breadcrumb.model';
import { BreadcrumbService } from '../../../../domain/service/breadcrumb/breadcrumb.service';
import { filter } from 'rxjs';

@Component({
  selector: "app-breadcrumb",
  standalone: true,
  imports: [RouterModule, NgIf, NgForOf, MatIcon],
  templateUrl: "./breadcrumb.component.html",
  styleUrl: "./breadcrumb.component.css",
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: BreadcrumbModel[] = [];
  showFather = true;
  constructor(
    private router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      console.log(this.breadcrumbs);
      this.breadcrumbs = this.buildBreadcrumb(this.route.root);
    });
  }

  ngOnInit(): void {}
  private buildBreadcrumb(
    route: ActivatedRoute,
    url: string = "",
    breadcrumbs: Array<{ label: string; url: string; icon: string; svgIcon?: string; urlLabel?: string; linkTo?: string }> = []
  ): Array<{ label: string; url: string }> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeConfig = child.routeConfig;

      if (routeConfig?.data?.["breadcrumb"]) {
        const routeURL: string = routeConfig.path ?? "";
        const nextURL = `${url}/${routeURL}`;
        breadcrumbs.push({
          label: routeConfig.data["breadcrumb"],
          url: nextURL,
          icon: routeConfig.data["icon"],
          svgIcon: routeConfig.data["svgIcon"],
          urlLabel: routeConfig.data["label"],
          linkTo: routeConfig.data["url"],
        });
        if (routeConfig.data["showFather"] === false) {
          this.showFather = false;
        }
        return this.buildBreadcrumb(child, nextURL, breadcrumbs);
      }
    }

    return breadcrumbs;
  }
}
